var render = function render(){
  var _vm$config, _vm$config$propertyCa, _vm$config2, _vm$config2$propertyC, _vm$config3, _vm$config3$propertyC, _vm$config4, _vm$config4$propertyC, _vm$config5, _vm$config5$propertyC, _vm$config6, _vm$config6$propertyC, _vm$config7, _vm$config7$propertyC, _vm$config8, _vm$config8$propertyC, _vm$config9, _vm$config9$propertyC, _vm$config10, _vm$config10$property, _vm$config11, _vm$config11$property, _vm$config12, _vm$config12$general, _vm$config13, _vm$config13$property, _vm$config14, _vm$config14$currency, _vm$config15, _vm$config15$general;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "living-option-card",
    class: {
      'living-option-card--active': _vm.isActive
    }
  }, [_c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.isFavourited(_vm.slide._id) ? _c('div', {
    staticClass: "living-option-card__fav-icon"
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'heart']
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "living-option-card__slide-image"
  }, [_vm.slide.dwellingOverlayImage ? _c('img', {
    staticClass: "living-option-card__overlay",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.slide.dwellingOverlayImage)
    }
  }) : _vm._e(), _vm.slide.packageOverlayImage ? _c('img', {
    staticClass: "living-option-card__overlay",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.slide.packageOverlayImage)
    }
  }) : _vm._e(), _vm.slide.images.length ? _c('img', {
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.slide.images[0])
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "living-option-card__details"
  }, [_c('div', {
    staticClass: "property-feature"
  }, [_vm.slide.name ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config = _vm.config) === null || _vm$config === void 0 ? void 0 : (_vm$config$propertyCa = _vm$config.propertyCard) === null || _vm$config$propertyCa === void 0 ? void 0 : _vm$config$propertyCa.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.slide.type === "dwelling" ? _vm.config.labels.dwellingLabel.en : _vm.config.labels.propertyLabel.en))]), _c('div', {
    staticClass: "property-feature__value"
  }, [_vm._v(_vm._s(_vm.slide.name))])]) : _vm._e(), _vm.slide.lotNumber ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config2 = _vm.config) === null || _vm$config2 === void 0 ? void 0 : (_vm$config2$propertyC = _vm$config2.propertyCard) === null || _vm$config2$propertyC === void 0 ? void 0 : _vm$config2$propertyC.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.propertyLabel)))]), _c('div', {
    staticClass: "property-feature__value"
  }, [_vm._v(_vm._s(_vm.slide.lotNumber))])]) : _vm._e(), _vm.$label(_vm.slide.houseDesign) ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config3 = _vm.config) === null || _vm$config3 === void 0 ? void 0 : (_vm$config3$propertyC = _vm$config3.propertyCard) === null || _vm$config3$propertyC === void 0 ? void 0 : _vm$config3$propertyC.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.dwellingLabel)))]), _c('div', {
    staticClass: "property-feature__value"
  }, [_vm._v(_vm._s(_vm.$label(_vm.slide.houseDesign)))])]) : _vm._e(), _vm.$label(_vm.slide.builder) ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config4 = _vm.config) === null || _vm$config4 === void 0 ? void 0 : (_vm$config4$propertyC = _vm$config4.propertyCard) === null || _vm$config4$propertyC === void 0 ? void 0 : _vm$config4$propertyC.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.dwellingBuilder)))]), _c('div', {
    staticClass: "property-feature__value"
  }, [_vm._v(_vm._s(_vm.$label(_vm.slide.builder)))])]) : _vm._e(), _vm.$label(_vm.slide.colourScheme) ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config5 = _vm.config) === null || _vm$config5 === void 0 ? void 0 : (_vm$config5$propertyC = _vm$config5.propertyCard) === null || _vm$config5$propertyC === void 0 ? void 0 : _vm$config5$propertyC.headingColour, ";")
  }, [_vm._v("Colour Scheme")]), _c('div', {
    staticClass: "property-feature__value"
  }, [_vm._v(_vm._s(_vm.$label(_vm.slide.colourScheme)))])]) : _vm._e(), _vm.slide.frontage ? _c('div', {
    staticClass: "property-feature__wrapper property-feature__wrapper--frontage"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config6 = _vm.config) === null || _vm$config6 === void 0 ? void 0 : (_vm$config6$propertyC = _vm$config6.propertyCard) === null || _vm$config6$propertyC === void 0 ? void 0 : _vm$config6$propertyC.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.frontage)))]), _c('div', {
    staticClass: "property-feature__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.slide.frontage) + "m")])]) : _vm._e(), _vm.slide.depth ? _c('div', {
    staticClass: "property-feature__wrapper property-feature__wrapper--depth"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config7 = _vm.config) === null || _vm$config7 === void 0 ? void 0 : (_vm$config7$propertyC = _vm$config7.propertyCard) === null || _vm$config7$propertyC === void 0 ? void 0 : _vm$config7$propertyC.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.depth)))]), _c('div', {
    staticClass: "property-feature__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.slide.depth) + "m")])]) : _vm._e(), _vm.slide.lotSize ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config8 = _vm.config) === null || _vm$config8 === void 0 ? void 0 : (_vm$config8$propertyC = _vm$config8.propertyCard) === null || _vm$config8$propertyC === void 0 ? void 0 : _vm$config8$propertyC.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.propertySize)))]), _c('div', {
    staticClass: "property-feature__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.slide.lotSize) + "m"), _c('sup', [_vm._v("2")])])]) : _vm._e(), _vm.slide.dwellingSize ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config9 = _vm.config) === null || _vm$config9 === void 0 ? void 0 : (_vm$config9$propertyC = _vm$config9.propertyCard) === null || _vm$config9$propertyC === void 0 ? void 0 : _vm$config9$propertyC.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.dwellingSize)))]), _c('div', {
    staticClass: "property-feature__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.slide.dwellingSize)), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$label(_vm.config.labels.dwellingSizeSuffix))
    }
  })])]) : _vm._e(), _vm.$label(_vm.slide.viewLabel) ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config10 = _vm.config) === null || _vm$config10 === void 0 ? void 0 : (_vm$config10$property = _vm$config10.propertyCard) === null || _vm$config10$property === void 0 ? void 0 : _vm$config10$property.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.viewLabel)))]), _c('div', {
    staticClass: "property-feature__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.$label(_vm.slide.viewLabel)))])]) : _vm._e(), _vm.slide.minimumFrontage ? _c('div', {
    staticClass: "property-feature__wrapper"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config11 = _vm.config) === null || _vm$config11 === void 0 ? void 0 : (_vm$config11$property = _vm$config11.propertyCard) === null || _vm$config11$property === void 0 ? void 0 : _vm$config11$property.headingColour, ";")
  }, [_vm._v("Minimum Frontage")]), _c('div', {
    staticClass: "property-feature__value"
  }, [_vm._v(_vm._s(_vm.slide.minimumFrontage) + "m")])]) : _vm._e(), (_vm$config12 = _vm.config) !== null && _vm$config12 !== void 0 && (_vm$config12$general = _vm$config12.general) !== null && _vm$config12$general !== void 0 && _vm$config12$general.showPrice && _vm.slide.price ? _c('div', {
    staticClass: "property-feature__wrapper property-feature__wrapper--price"
  }, [_c('div', {
    staticClass: "property-feature__label",
    style: "color: ".concat((_vm$config13 = _vm.config) === null || _vm$config13 === void 0 ? void 0 : (_vm$config13$property = _vm$config13.propertyCard) === null || _vm$config13$property === void 0 ? void 0 : _vm$config13$property.headingColour, ";")
  }, [_vm._v(_vm._s(_vm.priceLabel))]), _c('div', {
    staticClass: "property-feature__value"
  }, [_vm._v(_vm._s(_vm.slide.price.toLocaleString("en-AU", {
    style: "currency",
    currency: (_vm$config14 = _vm.config) === null || _vm$config14 === void 0 ? void 0 : (_vm$config14$currency = _vm$config14.currency) === null || _vm$config14$currency === void 0 ? void 0 : _vm$config14$currency.code,
    maximumSignificantDigits: 10
  })))])]) : _vm._e(), _c('div', {
    staticClass: "property-feature__btn-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive && _vm.slide.virtualTourUrl && _vm.isMatterportAvailable,
      expression: "isActive && slide.virtualTourUrl && isMatterportAvailable"
    }],
    staticClass: "btn touch",
    staticStyle: {
      "bottom": "2.4rem"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.openVirtualTour(_vm.slide.virtualTourUrl);
      }
    }
  }, [_c('span', [_vm._v("Virtual Tour")])])]), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive,
      expression: "isActive"
    }],
    staticClass: "btn touch details-button",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.openModal(_vm.slide._id);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$label(_vm.config.labels.details)))])])])], 1)]), _c('div', {
    staticClass: "dwelling-feature"
  }, [_vm.slide.beds ? _c('div', {
    staticClass: "dwelling-feature__wrapper"
  }, [_c('div', {
    staticClass: "dwelling-feature__value"
  }, [_vm._v(_vm._s(_vm.slide.beds))]), _c('div', {
    staticClass: "dwelling-feature__icon"
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'bed']
    }
  })], 1)]) : _vm._e(), _vm.slide.baths ? _c('div', {
    staticClass: "dwelling-feature__wrapper"
  }, [_c('div', {
    staticClass: "dwelling-feature__value"
  }, [_vm._v(_vm._s(_vm.slide.baths))]), _c('div', {
    staticClass: "dwelling-feature__icon"
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'bath']
    }
  })], 1)]) : _vm._e(), _vm.slide.cars ? _c('div', {
    staticClass: "dwelling-feature__wrapper"
  }, [_c('div', {
    staticClass: "dwelling-feature__value"
  }, [_vm._v(_vm._s(_vm.slide.cars))]), _c('div', {
    staticClass: "dwelling-feature__icon"
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'car']
    }
  })], 1)]) : _vm._e(), (_vm$config15 = _vm.config) !== null && _vm$config15 !== void 0 && (_vm$config15$general = _vm$config15.general) !== null && _vm$config15$general !== void 0 && _vm$config15$general.showFavourites ? [_c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.isActive ? [!_vm.isFavourited(_vm.slide._id) ? _c('button', {
    staticClass: "btn-circle btn-circle--favourites-add touch",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.addToFavourites(_vm.slide);
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'heart']
    }
  })], 1) : _vm._e(), _vm.isFavourited(_vm.slide._id) ? _c('button', {
    staticClass: "btn-circle btn-circle--favourites-remove touch",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.removeFromFavourites(_vm.slide);
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'trash']
    }
  })], 1) : _vm._e()] : _vm._e()], 2)] : _vm._e()], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }